const sv = {
  home: {
    biometric_label: "BIOMETRISK IDENTITETSVERIFIERING",
    title: "Omvänd ansiktssökning enkelt gjort",
    description:
      "Ladda upp ett högupplöst porträtt för att korshänvisa mot globala digitala arkiv med avancerad neural matchning.",
    drag_drop: "Dra och släpp din bild",
    file_formats: "Stöder RAW, JPEG eller PNG (Max 15MB)",
    select_file: "VÄLJ FIL FRÅN SYSTEMET",
    initiate_scan: "Starta Kriminalteknisk Skanning",
    upload_hint: "LADDA UPP EN BILD FÖR ATT FORTSÄTTA",
    uploading: "Laddar upp",
    searching: "Skannar",
    result_title: "Resultat",
    drop_here: "Släpp bilden här...",
    billion_faces: "Jämför med över 1 miljard ansikten på internet",
    login_to_search: "Logga in för att söka",
    login_required: "Logga in eller skapa ett konto för att använda denna app",
    not_enough_tokens: "Inte tillräckligt med tokens",
    please_wait: "Vänta några minuter",
    leave_confirmation: "En process pågår. Är du säker på att du vill lämna?",
  },
  sources: {
    section_title: "Källor vi Söker Igenom",
    social_media: {
      name: "Sociala Medier",
      description:
        "Korshänvisningar i stora sociala nätverk och offentliga profiler.",
    },
    web: {
      name: "Webb",
      description:
        "Skannar det öppna webbet efter offentligt tillgänglig ansiktsdata.",
    },
    scammers: {
      name: "Bedragare",
      description:
        "Matchar mot kända bedragares identitets- och bedrägeridata.",
    },
    sexual_offenders: {
      name: "Sexualförbrytare",
      description:
        "Korshänvisningar med offentliga registrerade brottslingars register.",
    },
    videos: {
      name: "Videor",
      description:
        "Extraherar och matchar ansikten från offentliga videoplattformar.",
    },
    police_photos: {
      name: "Polisfoto",
      description: "Jämför med offentligt tillgängliga polisdatabaser.",
    },
    news_and_blogs: {
      name: "Nyheter & Bloggar",
      description: "Söker i nyhetsarkiv, redaktionellt innehåll och bloggar.",
    },
  },
  header: {
    scan: "SKANNA",
    history: "HISTORIK",
    pricing: "PRISER",
    account: "KONTO",
    logout: "LOGGA UT",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Alla rättigheter förbehållna. Precisionsidentitetsverifiering.",
    privacy: "Integritetspolicy",
    terms: "Användarvillkor",
    docs: "Dokumentation",
    support: "Support",
  },
  common: {
    loading: "Laddar...",
    error: "Fel",
    cancel: "Avbryt",
    back: "Tillbaka",
  },
  errors: {
    upload_failed: "Uppladdning misslyckades. Försök igen.",
    not_enough_tokens:
      "Du har inte tillräckligt med tokens för att utföra denna sökning.",
  },
  login: {
    disclaimer:
      "Du behöver ett konto för att använda den här appen. Vi skickar ingen spam och delar inte din e-post. Vi föreslår att du loggar in med Apple för att skydda din integritet.",
  },
  results: {
    input_source: "INGÅNGSKÄLLA",
    match_thumbnail: "Miniatyrbild för träffen",
    extraction_id: "EXTRAKTIONS-ID",
    scan_analysis: "Skanningsanalys",
    scan_description:
      "Biometrisk omvänd sökning slutförd. Hittade %{count} potentiella matchningar i offentliga register och sociala index.",
    col_identity_map: "IDENTITETSKARTA",
    col_verification_path: "VERIFIERINGSSTIG",
    col_bio_match_score: "BIO-MATCHNINGSPOÄNG",
    col_action: "ÅTGÄRD",
    export_pdf: "Exportera PDF",
    exporting: "Genererar...",
    verified: "VERIFIERAD",
    details: "DETALJER",
    details_tooltip: "Kör exakt ansiktsjämförelse",
    details_loading: "Jämför...",
    copied: "Kopierat!",
    copy_url: "Kopiera URL",
    displaying: "Visar %{count} av %{total} detektioner",
  },
};

export default sv;
